<template>
    <v-container fluid>
        <div class="text-h6 white--text d-md-none" style="margin-top: 10px;">Pagamento PIX</div>
        <div class="text-h6 black--text d-none d-md-block" style="margin-top: 10px;">Pagamento PIX</div>
        <div style="background-color: white; padding: 8px;">
            <qrcode-vue class="text-center" :value="carrinho.pix" size="200" level="L" renderAs="canvas"></qrcode-vue>
        </div>
        <div class="mx-auto">Pedido#<b>{{ carrinho.id }}</b></div>
        <div class="mx-auto">Favorecido: <b>Revolution Serviços</b></div>
        <div class="mx-auto">CNPJ: <b>05.411.490/0001-32</b></div>
        <div class="mx-auto">Valor: <b>R$ {{ totalCarrinho | fmtNumber }}</b></div>
        <div class="mx-auto text-center" @click="copyToClipboard()"><v-btn >Copiar Pix Copia e Cola</v-btn></div>
        <div>Clique no botão para copiar o código PIX e logo após vá para seu aplicativo do banco e selecione a opção Pix Copia e cola e cole o conteudo lá.</div>
        <h1 class="text-center">Verificando pagamento pix em {{ timeout }} segundos</h1>
        <div class="text-subtitle-1" style="padding-top: 10px; line-height: 25px;">
            Caso necessite de urgência na confirmação de pagamento envie um Whats para <a href="https://wa.me/555199926208">(51) 99992-6208</a> com Edgar,
            (basta clicar no telefone para abrir o whatsapp)
        </div>
    </v-container>
</template>
<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import QrcodeVue from 'qrcode.vue'

export default {
  components: { QrcodeVue },
  data: () => ({
    timeout: 15,
    timeInt: null

  }),
  computed: {
    ...mapState(['carrinho']),
    ...mapGetters(['totalCarrinho'])
  },
  mounted () {
    if (this.carrinho.voucher == '')
      this.$router.push('/pagamento/selecione')
    this.diminuiContagem();
  },
  methods: {
    ...mapActions(['consultaVoucher']),
    diminuiContagem() {
      this.timeInt = setTimeout(() => {
        this.timeout--;
        if (this.timeout ==0) {
          this.consultaVoucher();
          this.timeout = 15;
        }
        if (this.timeout > 0)
          this.diminuiContagem();
      }, 1000)
    },
    copyToClipboard () {
      window.navigator.clipboard.writeText(this.carrinho.pix).then(() => {
        alert('PIX copiado, vá para o app do banco e cole na opção Pix Copia e cola')
      }).catch(err => {
        alert('Erro copiando texto ' + err)
      })
    }
  }
}
</script>
